import React from 'react';
import './Footer.css'; // Make sure to style the footer using a CSS file

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-left">
          <p>&copy; {new Date().getFullYear()} Wayzre. All Rights Reserved.</p>
        </div>
        <div className="footer-center">
          <ul className="footer-links">
            <li><a href="https://propertyoffer.appvelo.com/createOffer">Create Offer</a></li>
            <li><a href="https://propertyoffer.appvelo.com/dashboard">Home</a></li>
            <li><a href="https://propertyoffer.appvelo.com/setting">Setting</a></li>
            <li><a href="https://propertyoffer.appvelo.com/profile">Profile</a></li>
          </ul>
        </div>
        <div className="footer-right">
          <ul className="social-media">
            <li>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTQKrFhY-ljA-u7J5IMWeTv8zmpBx4PP9nQMw&s" alt="Facebook" />
              </a>
            </li>
            <li>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTI-h-e2hgz8mwGfCt4gvj4IgMG_wAUolVM6w&s" alt="Twitter" />
              </a>
            </li>
            <li>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQHP2W0X8Bj9Wwou8Y5Iv2q_Aa-nME9SMwEAA&s" alt="Instagram" />
              </a>
            </li>
            {/* <li>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                <img src="https://cdn-icons-png.flaticon.com/512/174/174857.png" alt="LinkedIn" />
              </a>
            </li> */}
          </ul>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
